module.exports = __webpack_public_path__ + "img/logo.e8b7b16.png";